import { BaseService } from '@common/http-layer/service/base.service'

import type { BrandedAppCustomization, BrandedAppMetadata } from '../types/branded-app'

export class BrandedAppService extends BaseService {
  constructor() {
    super({
      baseURL: 'CLIENTPORTAL_SERVER_URL',
      basePath: '',
    })
  }

  async fetchCustomization(locationId: string): Promise<BrandedAppCustomization> {
    const { data } = await this.get<BrandedAppCustomization>(`/branded-app/${encodeURIComponent(locationId)}/customization`)
    return data
  }

  async fetchMetadata(locationId: string, signal?: AbortSignal): Promise<BrandedAppMetadata> {
    const { data } = await this.get<BrandedAppMetadata>(`/branded-app/${encodeURIComponent(locationId)}/metadata`, { signal })
    return data
  }
}
